import { Box, Typography, useTheme, Button } from "@mui/material";
import { tokens } from "../../theme";
import Divider from '@mui/material/Divider';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons'

import { useState } from "react";
import toast from 'react-hot-toast';

const InforCardSeller = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { title, value, editable, handleUpdate, valueUpdate, paddingHere, valueCopy = false } = props

    const [isPressed, setIsPressed] = useState(false);
    const [copied, setCopied] = useState(false);



    const hanlerOpenEmail = (email) => {
        console.log('email', email)
        const emailTo = `mailto:${email}`;
        window.location = emailTo
    }

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500); // feedback temporário
            toast.success('Copiado com sucesso!', {
                position: 'top-right',
                autoClose: 3000,          // Fecha automaticamente após 3 segundos
                hideProgressBar: true,   // Mostra a barra de progresso
                closeOnClick: true,       // Fecha ao clicar
                pauseOnHover: true,       // Pausa o timer ao passar o mouse
                draggable: true,          // Permite arrastar o toast
                progress: undefined,      // Deixa o controle do progresso automático
            });
        } catch (err) {
            toast.error('Erro ao copiar o conteúdo');
            console.error('Erro ao copiar:', err);
        }
    };
    return (
        <>
            <Box
                sx={{
                    paddingLeft: '10px',
                    overflow: 'hidden',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: '10px',
                        cursor: title === 'E-mail' && 'pointer',
                        opacity: isPressed ? 0.7 : 1, // Adjust opacity on click
                        transition: 'opacity 0.2s ease' // Smooth transition
                    }}
                    onClick={() => title === 'E-mail' && hanlerOpenEmail(value)}
                    onMouseDown={() => setIsPressed(true)}
                    onMouseUp={() => setIsPressed(false)}
                    onMouseLeave={() => setIsPressed(false)}
                >
                    {
                        title === 'E-mail' &&
                        <FontAwesomeIcon
                            color={colors.primary[100]}
                            icon={faEnvelope}
                            size="1x"
                            style={{
                                filter: "drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4))",
                                paddingTop: '10px',
                            }}
                        />
                    }
                    <Typography variant="h6" color={'whitesmoke'} sx={{ paddingTop: '10px', fontWeight: 'bold' }}>
                        {title}
                    </Typography>
                    {
                        valueCopy &&

                        <Button
                            onClick={handleCopy}
                            sx={{
                                minWidth: '40px',
                                height: '40px',
                                padding: '10px',
                                color: copied ? 'green' : '#facc15', // colors.yellow[600]
                                fontSize: '16px',
                                borderRadius: '4px',
                                marginLeft: 'auto'
                            }}
                        >
                            <FontAwesomeIcon
                                size="xs"
                                icon={faCopy}
                            />
                        </Button>
                    }
                    {editable &&
                        <Button
                            onClick={() => handleUpdate(!valueUpdate)}
                            sx={{
                                minWidth: '40px',  // Sets a minimum width for the button
                                height: '40px',     // Sets a fixed height for the button
                                padding: '10px',    // Adjusts padding for larger clickable area
                                color: colors.yellow[600],
                                fontSize: '16px',   // Increases font size
                                borderRadius: '4px', // Optional: Adjust border radius,
                                marginLeft: 'auto'
                            }}
                        >
                            <FontAwesomeIcon
                                size="xs"
                                icon={faPenToSquare}
                            />
                        </Button>
                    }
                </Box>
                <Typography variant="h6" color={colors.primary[100]} fontWeight={"bold"} textAlign={"justify"} padding={paddingHere}
                    sx={{ paddingRight: title === 'Endereço de Troca' && '10px', }}
                >
                    {value || "N/A"}
                </Typography>
            </Box>
            <Divider variant="middle" />
        </>

    );
}

export default InforCardSeller;